module.exports = __webpack_public_path__ + "img/extensionvideo.cf7429e7.svg";